import { OverflowTooltip } from '@/components/common/overflow-tooltip';
import type { OrderDetail } from '@/features/orders';

import { addressLines } from '../address-lines';

import { DetailCard, DetailRow } from './detail-card';
import styles from './logistics-card.module.scss';

/**
 * An address reads as its street over its `City, State ZIP`, so the city is never broken across
 * two lines; each line ellipsises on its own. An address whose city cannot be found is clamped to
 * two lines as one block. Either way the full value is in the tooltip (121203).
 */
function Address({ value, city }: { value: string; city: string }) {
  const lines = addressLines(value, city);
  return (
    <OverflowTooltip title={value}>
      {lines.length === 1 ? (
        <span className={styles.address}>{value}</span>
      ) : (
        <span className={styles.lines}>
          {lines.map((line) => (
            <span key={line} className={styles.line}>
              {line}
            </span>
          ))}
        </span>
      )}
    </OverflowTooltip>
  );
}

export function LogisticsCard({ order }: { order: OrderDetail }) {
  const { logistics } = order;

  return (
    <DetailCard title="Logistics">
      <DetailRow label="City" value={logistics.city} />
      <DetailRow
        label="Billing Address"
        value={<Address value={logistics.billingAddress} city={logistics.city} />}
      />
      <DetailRow
        label="Shipping Address"
        value={<Address value={logistics.shippingAddress} city={logistics.city} />}
      />
    </DetailCard>
  );
}
